import { Provinces } from '@dofleini/location-ui';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const ProvinceSelect = ({ value, onChange, ...props }) => {
  return (<Provinces
    {...props}
    onChange={onChange}
    value={value}
    canSearch
  />);
};

export default memo(ProvinceSelect);

ProvinceSelect.propTypes = {
  value: PropTypes.any,
  editing: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  helperText: PropTypes.string
};

ProvinceSelect.defaultProps = {};

// eslint-disable-next-line react/prop-types
export const renderProvinceSelect = ({ formItemProps, field }) => {
  return (
    // eslint-disable-next-line react/prop-types
    <Form.Item {...formItemProps} required={field?.required}>
      <ProvinceSelect {...field}/>
    </Form.Item>
  );
};
